import { TranslationsContext } from '@teliaee/telia-translate';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ISelectOption, Select, TSelectValue } from 'telia-front-react';
import { useStores } from '../../../stores/RootStore';

const options: ISelectOption[] = [
  {
    value: 'et',
    label: 'Eesti'
  },
  {
    value: 'en',
    label: 'English'
  },
  {
    value: 'ru',
    label: 'Pусский'
  }
];

const LanguageSelection = observer((): React.JSX.Element => {
  const { callbackStore } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  const updateValue = ({ value }: ISelectOption) => {
    runInAction(() => (callbackStore.callbackCreation.language = value));
    callbackStore.updateReservationCreationBranchId();
  };

  return (
    <Select
      id="language"
      label={translate('reservation.requestCallback.language.label')}
      options={options}
      value={options.find((o) => o.value === callbackStore.callbackCreation.language.toLowerCase())}
      onChange={(value: TSelectValue) => updateValue(value as ISelectOption)}
    />
  );
});

export default LanguageSelection;
